import React, { useState, useEffect } from 'react';
import { UPLOADS_BASE } from '../api';

const LINKS = [
  { href: '#tranches',    label: 'Tranches' },
  // { href: '#impact',      label: 'Impact' },
  { href: '#partenaires', label: 'Partenaires' },
  { href: '#documents',   label: 'Documents' },
  { href: '#contacts',    label: 'Contact' },
];

export default function Navbar({ settings }) {
  const [open, setOpen]       = useState(false);
  const [scrolled, setScrolled] = useState(false);

  const logoPath   = settings['logo.path']      ? `${UPLOADS_BASE}${settings['logo.path']}` : null;
  const logoAlt    = settings['logo.alt']        || 'ZAKA';
  const subtitle   = settings['nav.subtitle']    || 'FCTC RMBS\nEcobank CI 2026';
  const ctaLabel   = settings['nav.cta_label']   || 'Nous écrire';
  const ctaHref    = settings['nav.cta_href']    || '#contacts';
  const navBg      = settings['nav.bg']          || '#FFFFFF';
  const linkColor  = settings['nav.link_color']  || '#1A2332';
  const ctaBg      = settings['nav.cta_bg']      || '#1B4F8A';
  const ctaColor   = settings['nav.cta_color']   || '#FFFFFF';
  const hasBorder  = settings['nav.border']      !== '0';
  const borderColor= settings['nav.border_color']|| '#E2DFDA';

  // Détermine si le fond est sombre pour adapter les icônes hamburger
  const isBgDark = (() => {
    const hex = navBg.replace('#','');
    if (hex.length < 6) return false;
    const r = parseInt(hex.slice(0,2),16);
    const g = parseInt(hex.slice(2,4),16);
    const b = parseInt(hex.slice(4,6),16);
    return (r*299 + g*587 + b*114) / 1000 < 128;
  })();

  useEffect(() => {
    const fn = () => setScrolled(window.scrollY > 10);
    window.addEventListener('scroll', fn);
    return () => window.removeEventListener('scroll', fn);
  }, []);

  const handleLink = () => setOpen(false);

  return (
    <>
      <style>{`
        .navbar {
          position: fixed; top: 0; left: 0; right: 0; z-index: 999;
          background: ${navBg};
          ${hasBorder ? `border-bottom: 1px solid ${borderColor};` : ''}
          ${scrolled ? 'box-shadow: 0 1px 12px rgba(0,0,0,0.08);' : ''}
          transition: box-shadow .3s;
        }
        .navbar-inner {
          max-width: 1200px; margin: 0 auto;
          padding: 0 1.2rem; height: 64px;
          display: flex; align-items: center; justify-content: space-between;
        }
        .navbar-logo { display: flex; align-items: center; gap: 10px; text-decoration: none; }
        .navbar-logo-text { font-family: 'Playfair Display',serif; font-size: 20px; font-weight: 900; color: ${ctaBg}; letter-spacing: 2px; }
        .navbar-sep { width: 1px; height: 24px; background: ${borderColor}; }
        .navbar-sub { font-size: 10px; color: ${linkColor}; opacity: 0.5; letter-spacing: 1.5px; text-transform: uppercase; line-height: 1.4; white-space: pre-line; }
        .navbar-links { display: none; align-items: center; gap: 1.6rem; }
        .navbar-links a { color: ${linkColor}; text-decoration: none; font-size: 18px; letter-spacing: .3px; transition: opacity .2s; opacity: 0.75; }
        .navbar-links a:hover { opacity: 1; }
        .navbar-cta {
          background: ${ctaBg}; color: ${ctaColor};
          padding: 8px 18px; border-radius: 4px;
          font-weight: 600; text-decoration: none; font-size: 13px;
          white-space: nowrap; opacity: 1 !important;
          transition: filter .2s;
        }
        .navbar-cta:hover { filter: brightness(1.1); }
        .navbar-hamburger { display: flex; flex-direction: column; gap: 5px; cursor: pointer; padding: 8px; background: transparent; border: none; }
        .navbar-hamburger span { display: block; width: 22px; height: 2px; background: ${isBgDark ? 'rgba(255,255,255,0.8)' : linkColor}; border-radius: 2px; transition: all .3s; }
        .navbar-hamburger.open span:nth-child(1) { transform: translateY(7px) rotate(45deg); }
        .navbar-hamburger.open span:nth-child(2) { opacity: 0; }
        .navbar-hamburger.open span:nth-child(3) { transform: translateY(-7px) rotate(-45deg); }
        .navbar-mobile {
          position: fixed; top: 64px; left: 0; right: 0; bottom: 0;
          background: ${navBg}; z-index: 998;
          display: flex; flex-direction: column; align-items: center; justify-content: center;
          gap: 1.8rem; transform: translateY(-100%); opacity: 0;
          transition: transform .3s ease, opacity .3s ease; pointer-events: none;
          ${hasBorder ? `border-top: 1px solid ${borderColor};` : ''}
        }
        .navbar-mobile.open { transform: translateY(0); opacity: 1; pointer-events: all; }
        .navbar-mobile a { color: ${linkColor}; text-decoration: none; font-size: 1.2rem; font-weight: 500; opacity: 0.8; }
        .navbar-mobile a:hover { opacity: 1; }
        .navbar-mobile .cta-mobile {
          background: ${ctaBg}; color: ${ctaColor};
          padding: 12px 32px; border-radius: 4px;
          font-weight: 600; font-size: 1rem; margin-top: 1rem; opacity: 1 !important;
        }
        @media (min-width: 768px) {
          .navbar-inner { padding: 0 2rem; height: 68px; }
          .navbar-links { display: flex; }
          .navbar-hamburger { display: none; }
          .navbar-mobile { display: none; }
        }
      `}</style>

      <nav className="navbar">
        <div className="navbar-inner">
          <a href="#" className="navbar-logo">
            {logoPath
              ? <img src={logoPath} alt={logoAlt} style={{ height: 36, objectFit: 'contain' }} />
              : <span className="navbar-logo-text">{logoAlt}</span>
            }
            <div className="navbar-sep" />
            <div className="navbar-sub">{subtitle}</div>
          </a>

          <div className="navbar-links">
            {LINKS.map(l => <a key={l.href} href={l.href}>{l.label}</a>)}
            {/* <a href={ctaHref} className="navbar-cta">{ctaLabel}</a> */}
          </div>

          <button className={`navbar-hamburger${open ? ' open' : ''}`} onClick={() => setOpen(!open)} aria-label="Menu">
            <span /><span /><span />
          </button>
        </div>
      </nav>

      <div className={`navbar-mobile${open ? ' open' : ''}`}>
        {LINKS.map(l => <a key={l.href} href={l.href} onClick={handleLink}>{l.label}</a>)}
        {/* <a href={ctaHref} className="cta-mobile" onClick={handleLink}>{ctaLabel}</a> */}
      </div>
    </>
  );
}
